import { render, staticRenderFns } from "./CodeStats.vue?vue&type=template&id=294758a4&scoped=true"
import script from "./CodeStats.vue?vue&type=script&lang=js"
export * from "./CodeStats.vue?vue&type=script&lang=js"
import style0 from "./CodeStats.vue?vue&type=style&index=0&id=294758a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294758a4",
  null
  
)

export default component.exports